import React from 'react';
import ChartComponent from './ChartComponent';
import { PieChartData } from '../../types';

// Interface para as propriedades do componente
interface PieChartComponentProps {
  data: PieChartData;
  title: string;
  loading?: boolean;
  error?: string | null;
  height?: number | string;
  colors?: string[];
  embedded?: boolean;
}

const PieChartComponent: React.FC<PieChartComponentProps> = ({
  data,
  title,
  loading = false,
  error = null,
  height = 350,
  colors = ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9900', '#00CC99', '#FF66CC', '#669900', '#7F8C8D'],
  embedded = false,
}) => {
  // Formatar os dados para o formato esperado pelo ChartComponent
  const chartData = {
    labels: data.labels,
    datasets: [
      {
        data: data.values,
        backgroundColor: colors,
        hoverBackgroundColor: colors,
      },
    ],
  };

  // Opções do gráfico
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
        align: 'center' as const,
        labels: {
          boxWidth: 15,
          padding: 15
        }
      },
      tooltip: {
        callbacks: {
          label: function(context: any) {
            const label = context.label || '';
            const value = context.raw || 0;
            const total = context.chart.data.datasets[0].data.reduce((a: number, b: number) => a + b, 0);
            const percentage = Math.round((value / total) * 100);
            return `${label}: ${value} (${percentage}%)`;
          }
        }
      }
    },
  };

  return (
    <ChartComponent
      chartType="pie"
      chartData={chartData}
      chartOptions={chartOptions}
      title={title}
      loading={loading}
      error={error}
      height={height}
      embedded={embedded}
    />
  );
};

export default PieChartComponent; 